export const PREFIX = '__VCHART';

export const DEFAULT_CHART_WIDTH = 500;
export const DEFAULT_CHART_HEIGHT = 500;
